import FooterV1 from './FooterV1';
import FooterV2 from './FooterV2';
import type { FooterProps as Props } from './types';
export default function Footer({
  extendStyles,
  copy,
  links,
  isLightMode = false,
  footerVersion = 'v1',
  footerBackgroundColor,
  footerTextColor,
  pageComponents
}: Props) {
  const bottomPaddingValue = pageComponents?.includes('StickyCTA') ? '11rem' : '1.25rem';
  const sharedProps = {
    copy,
    links,
    isLightMode,
    extendStyles,
    footerBackgroundColor,
    footerTextColor,
    bottomPaddingValue
  };
  return footerVersion === 'v1' ? <FooterV1 {...sharedProps} data-sentry-element="FooterV1" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx" /> : <FooterV2 {...sharedProps} data-sentry-element="FooterV2" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx" />;
}